/*jshint esversion: 8 */

import Vue from "vue";
import Vuex from "vuex";
import { i18n } from "../../plugins/i18n.js";

Vue.use(Vuex);
console.log(i18n.messages[i18n.locale]);
import timeAccounts from "./users/timeAccounts";
import reports from "./users/reports";

export default {
  namespaced: true,
  state: {
    userList: [],
    employeeList: [],
    sapUserList: [],
    groups: [],
    processing: false,
    teams: [],
    presenceList: [],
    starredUsers: JSON.parse(window.localStorage.getItem("starredUsers"))
  },
  modules: {
    timeAccounts,
    reports
  },
  mutations: {
    setUsers(state, users) {
      state.userList = users;
    },
    setEmployees(state, employees) {
      state.employeeList = employees;
    },
    setSAPUsers(state, sapUsers) {
      state.sapUserList = sapUsers;
    },
    setGroups(state, groups) {
      state.groups = groups;
    },
    updateGroups(state, val) {
      state.processing = val;
    },
    update(state, val) {
      state.processing = val;
    },
    deleteUsers(state, val) {
      state.processing = val;
    },
    setTeams(state, teams) {
      state.teams = [i18n.messages[i18n.locale].all];
      for (let i = 0; i < teams.length; i++) state.teams.push(teams[i].TeamName);
    },
    setPresenceList(state, userList) {
      state.presenceList = userList;
    },
    setStarredUsers: (state, value) => {
      if (!state.starredUsers) state.starredUsers = [];
      state.starredUsers.push(value);
      window.localStorage.setItem("starredUsers", JSON.stringify(state.starredUsers));
    },
    removeStarredUsers: (state, value) => {
      if (!state.starredUsers) state.starredUsers = [];

      const index = state.starredUsers.findIndex((e) => e.SAPEmpId === value.SAPEmpId);
      state.starredUsers.splice(index, 1);
      window.localStorage.setItem("starredUsers", JSON.stringify(state.starredUsers));
    }
  },
  actions: {
    setUserStatus({ commit }, userObject) {
      commit("update", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/" + userObject.SAPEmpID + "/UserStatus/" + userObject.UserStatus,
            method: "PATCH"
          })
          .then((resp) => {
            commit("update", false);
            resolve(resp);
          })
          .catch((err) => {
            commit("update", false);
            console.log(err);
            reject(err);
          });
      });
    },
    getUsers({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/users/")
          .then((resp) => {
            commit("setUsers", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getEmployees({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/users/?validEmployees=true")
          .then((resp) => {
            commit("setEmployees", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getEmployeesFromSameTeam({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/${userId}/getEmployeesFromSameTeam`,
            method: "GET"
          })
          .then((resp) => {
            commit("setEmployees", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getGroups({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/groups/")
          .then((resp) => {
            commit("setGroups", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setGroupsForUser({ commit }, User) {
      commit("updateGroups", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/" + User.SAPEmpID,
            data: User.groups,
            method: "PATCH"
          })
          .then((resp) => {
            commit("updateGroups", false);
            resolve(resp);
          })
          .catch((err) => {
            commit("updateGroups", false);
            console.log(err);
            reject(err);
          });
      });
    },
    getSAPUsers({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/users/getSAPUsers")
          .then((resp) => {
            if (resp.data.success) {
              commit("setSAPUsers", resp.data.data);
            } else {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTeams({ commit }) {
      return Vue.prototype.$http
        .get(Vue.prototype.apiUrl + "/api/teams")
        .then((resp) => {
          if (resp.data.success) {
            commit("setTeams", resp.data.data);
          } else {
            // ToDo: Display Error
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteUsers({ commit }, users) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users",
            method: "DELETE",
            data: users
          })
          .then((resp) => {
            commit("deleteUsers", false);
            resolve(resp);
          })
          .catch((err) => {
            commit("deleteUsers", false);
            console.log(err);
            reject(err);
          });
      });
    },
    createSAPUsers({ commit }, importSapUsers) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/createSAPUsers",
            data: importSapUsers,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getPresenceList({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getPresenceList",
            method: "GET"
          })
          .then((resp) => {
            commit("setPresenceList", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    activateUser({ commit }, sapEmpID) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/activateUser/${sapEmpID}`,
            method: "PATCH"
          })
          .then((resp) => {
            commit("setPresenceList", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getMiniPresenceList() {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/miniPresenceList`,
            method: "GET"
          })
          .then((resp) => {
            //commit("setPresenceMiniList", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setStarredUser({ commit }, user) {
      commit("setStarredUsers", user);
    },
    removeStarredUser({ commit }, user) {
      commit("removeStarredUsers", user);
    }
  },
  getters: {
    userList: (state) => state.userList,
    employeeList: (state) => state.employeeList,
    sapUserList: (state) => state.sapUserList,
    groupList: (state) => state.groups,
    teams: (state) => state.teams,
    presenceList: (state) => state.presenceList,
    starredUsers: (state) => state.starredUsers
  }
};
